// ////////////////////////////////////////////////////
// State  (ROOT)
// ////////////////////////////////////////////////////

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  route: {},
  cognitoUserData: {},
  activeTeam: {},
  activeWorkspace: null,
  isNotFound: false,
  browzwearAPI: window.BwApi,
  isDarkMode: window.isDarkMode,
  seasons: []
})

export default getDefaultState
